export default "__VITE_ASSET__B3iJIrZ2__"